import styled from 'styled-components';
import Media from '../../utils/media';

/* -------------------------- FOOTER --------------------------- */
export const FooterStyled = styled.div`
  margin-top: 80px;
  background-image: url('images/footer/banner.png');
  background-size: auto;
  background-repeat: no-repeat;
  background-position: center;

  display: flex;
  align-items: center;
  justify-content: space-between;

  ${Media.lessThan(Media.SIZE.MD)} {
    content: 'Media.SIZE.XS';

    margin-top: 20px;
    background-image: url('images/footer/banner.png');
    background-size: initial;
    background-repeat: no-repeat;
    background-position: center;

    display: flex;
    align-items: center;
    padding: 10px 15px;
    height: max-content;
  }
`;

export const FooterImageStyled = styled.div`
  margin-left: 95px;

  ${Media.lessThan(Media.SIZE.XL)} {
    margin-left: 45px;

    img {
      width: 380px;
    }
  }

  ${Media.lessThan(Media.SIZE.MD)} {
    margin-left: unset;

    img {
      width: 160px;
    }
  }
`;

export const FooterContentStyled = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  margin-right: 95px;

  .message {
    font-family: Merienda;
    font-size: 36px;
    font-weight: 300;
    text-align: center;
    color: #ffffff;
  }

  ${Media.lessThan(Media.SIZE.XL)} {
    content: 'Media.SIZE.MD';
    margin-right: initial;

    .message {
      font-family: Merienda;
      font-size: 24px;
      font-weight: 300;
      text-align: center;
      color: #ffffff;
    }
  }

  ${Media.lessThan(Media.SIZE.SM)} {
    content: 'Media.SIZE.SM';
  }

  ${Media.lessThan(Media.SIZE.MD)} {
    content: 'Media.SIZE.XS';

    .message {
      font-family: Merienda;
      font-size: 13px;
      font-weight: 300;
      text-align: center;
      color: #ffffff;
      margin-left: unset; // left is real + right is estimate
    }
  }
`;

export const FooterContactStyled = styled.div`
  margin-top: 30px;

  img {
    margin-left: 20px;
    cursor: pointer;

    &:first-child {
      margin-left: 30px;
    }
  }

  ${Media.lessThan(Media.SIZE.XL)} {
    content: 'Media.SIZE.MD';

    margin-left: 15px;

    img {
      margin-left: 30px;
      width: 35px;

      &:first-child {
        margin-left: 60px;
      }
    }
  }

  ${Media.lessThan(Media.SIZE.MD)} {
    content: 'Media.SIZE.XS';

    margin-top: 35px;

    img {
      margin-left: unset;
      width: 35px;

      &:first-child {
        margin-left: unset;
      }

      &:not(:first-child) {
        margin-left: 20px;
      }
    }
  }
`;
